import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown } from '_components';
import styles from './Common.module.css';


class AlEvalRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLEVAL', 'XLEV', this.props.eval.XLEVNO);
    }

    render() {
        return (
            <div className={styles.row}>
                <div className={styles.remove_button}>
                    <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                </div>
                <DBDropDown
                    field='XLEVRTNO'
                    noteId={this.props.noteId}
                    entity='MLEVAL'
                    entityKeyColumn='XLEVNO'
                    entityKeyValue={this.props.eval.XLEVNO}
                    className={styles.col1}
                    customOptions={this.props.evalCodes}
                />
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch)
    };
}
function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));

    let evalCodes = Object.keys(state.entities.notes.EVALCODES)
        .filter(key => {
            return (
                (
                    (noteType === 1 && state.entities.notes.EVALCODES[key].RTEVNO === pk) ||
                    (noteType !== 1 && state.entities.notes.EVALCODES[key].RTNTNO === pk)
                ) &&
                !state.entities.notes.EVALCODES[key].RTCODE.includes('POC')
            )
        })
        .sort((a, b) => state.entities.notes.EVALCODES[a].RTDESC.localeCompare(state.entities.notes.EVALCODES[b].RTDESC))
        .map(key => ({ id: state.entities.notes.EVALCODES[key].RTNO, value: state.entities.notes.EVALCODES[key].RTDESC }));

    return {
        noteId: noteId,
        xlno: xlno,
        eval: state.entities.notes.MLEVAL[ownprops.id],
        evalCodes: evalCodes

    };
}

const connectedAlEvalRow = connect(mapStateToProps, mapDispatchToProps)(AlEvalRow);
export { connectedAlEvalRow as AlEvalRow };

